import React from 'react';
import './nav.css';
import walmartLogo from '../../svg/walmart.svg';
import rtLogo from '../../svg/rt_white.svg';

class Nav extends React.Component {
  render() {
    return (
      <div className='nav'>
        <a href="https://www.walmart.com">
          <img src={walmartLogo} className="walmart-logo" alt="Walmart Logo" />
        </a>
        <a href="https://www.realtree.com">
          <img src={rtLogo} className="rt-logo" alt="Realtree Logo" />
        </a>
      </div>
    )
  }
}

export default Nav;


// WEBPACK FOOTER //
// ./src/components/nav/nav.js